import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, filter, first, switchMap } from 'rxjs/operators';
import { LocationService } from './location.service';
import { Product } from 'app/models/Product';
import { Nursery } from 'app/models/Nursery';
import { Location } from '../models/Location';
import { StatesService } from './states.service';

@Injectable()
export class PollinatorService {
  constructor(
    private http: HttpClient,
    private locationService: LocationService,
    private statesService: StatesService
  ) {}

  getPollinatorData(pollinator: string, page = 1, perPage = 25): Observable<{ plants: any[], pagination: any }> {
    return this.locationService.location.pipe(
      filter(loc => loc !== null),
      first(),
      switchMap(currentLocation =>
        this.http.get<any>(`product/pollinator/${pollinator}?page=${page}&per_page=${perPage}`).pipe(
          map(response => {
            const plants = response.plants.map(rawPlant => {
              const transformedNurseries = rawPlant.nurseries.map(nursery =>
                this.transformNursery(nursery, currentLocation)
              );

              return new Product({
                ...rawPlant,
                locations: transformedNurseries
              });
            });

            return {
              plants: plants,
              pagination: response.pagination
            };
          }),
          catchError(this.handleError)
        )
      )
    );
  }

  // 🔁 Internal Handlers

  private transformNursery(nursery: any, currentLocation: Location): Nursery {
    if (!nursery.lat_long) {
      console.warn(`nursery ${nursery.id} has no lat long`);
    }
    const [lat, lng] = nursery.lat_long.split(',');
    return new Nursery({
      ...nursery,
      lat_lng: {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      },
      state: this.statesService.getStateFromIdOrDefault(nursery.state_id),
      currentLocation
    });
  }

  private handleError = (error: any) => {
    console.error('[PollinatorService Error]', error);
    console.log(error);
    return throwError(() => error);
  };
}
